import { queryOptions } from '@tanstack/react-query';

import { exchangeApiV1 } from 'lib/api/exchangeApi';

import type { RefereeFunnelStep, RewardDetails, RewardType, VariableClaim } from './referralsSummary';

export type ChecklistVariant = 'standard' | 'referee';

/** The perps fee-share referee's own live fee reduction. */
export type FeeReduction = {
    reduction_bps: number;
};

export type NewUserChecklistReferee = {
    id: string;
    reward_type: RewardType;
    claim_available: boolean;
    variable_claim?: VariableClaim;
    reward_details?: RewardDetails;
    fee_reduction?: FeeReduction;
};

export type GetNewUserChecklistResponse =
    | { variant: 'standard'; steps: RefereeFunnelStep[] }
    | { variant: 'referee'; steps: RefereeFunnelStep[]; referee: NewUserChecklistReferee };

export const newUserChecklistKeys = {
    all: ['newUserChecklist'] as const,
    user: (userId: string) => [...newUserChecklistKeys.all, userId] as const,
};

const getNewUserChecklist = async (signal?: AbortSignal): Promise<GetNewUserChecklistResponse> => {
    const response = await exchangeApiV1.get<GetNewUserChecklistResponse>('/rewards/new_user_checklist', { signal });
    return response.data;
};

export const newUserChecklistOptions = (userId: string) =>
    queryOptions({
        queryKey: newUserChecklistKeys.user(userId),
        queryFn: ({ signal }) => getNewUserChecklist(signal),
        staleTime: 30_000,
    });
